var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.405 21.83c0 .332-.27.607-.602.607H.603A.607.607 0 0 1 0 21.83c0-5.358 4.344-9.702 9.703-9.702s9.702 4.344 9.702 9.702M9.703 10.915A5.457 5.457 0 1 1 9.703 0a5.457 5.457 0 0 1 0 10.915",
    clipRule: "evenodd"
  })));
};
export default SvgPerson;